var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscoverPaymentCard(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 35,
    viewBox: "0 0 52 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 0h44a4 4 0 014 4v27a4 4 0 01-4 4H4a4 4 0 01-4-4V4a4 4 0 014-4z",
    fill: "#D1D1D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 1a3 3 0 00-3 3v27a3 3 0 003 3h44a3 3 0 003-3V4a3 3 0 00-3-3H4z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51 20.22S37.51 29.74 12.8 34H48a3 3 0 003-3V20.22z",
    fill: "#F46F1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.917 15.806c0 2.116 1.66 3.755 3.798 3.755.604 0 1.122-.118 1.76-.419V17.49c-.561.562-1.058.788-1.695.788-1.413 0-2.417-1.025-2.417-2.482 0-1.381 1.036-2.471 2.352-2.471.67 0 1.176.239 1.76.81v-1.652c-.616-.312-1.123-.442-1.727-.442-2.126 0-3.831 1.673-3.831 3.765zM14.315 14.059c0 .389.247.594 1.09.906 1.596.584 2.07 1.101 2.07 2.244 0 1.394-1.024 2.363-2.483 2.363-1.068 0-1.844-.42-2.49-1.37l.906-.873c.323.625.862.96 1.532.96.626 0 1.09-.432 1.09-1.015 0-.302-.14-.561-.421-.744-.141-.087-.421-.216-.97-.41-1.319-.475-1.771-.982-1.771-1.974 0-1.177.971-2.061 2.244-2.061.79 0 1.511.27 2.115.797l-.735.962c-.365-.41-.71-.583-1.131-.583-.605 0-1.046.345-1.046.798z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.06 12.204H4v7.195h2.05c1.09 0 1.876-.257 2.567-.83a3.611 3.611 0 001.306-2.762c0-2.124-1.587-3.603-3.863-3.603zm1.64 5.405c-.441.399-1.014.572-1.92.572h-.378v-4.758h.377c.907 0 1.457.162 1.92.582.486.432.778 1.102.778 1.791 0 .69-.292 1.381-.777 1.814z",
    fill: "#000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.569 19.4h1.404v-7.196h-1.404v7.195zM32.685 12.204l1.919 4.833 1.943-4.833h1.522l-3.109 7.38h-.755l-3.054-7.38h1.534zM38.703 19.4h3.98V18.18h-2.577V16.24h2.483V15.02h-2.483v-1.597h2.578v-1.22h-3.98V19.4z",
    fill: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.695 12.204c1.619 0 2.546.777 2.546 2.124 0 1.102-.582 1.825-1.639 2.04l2.265 3.032h-1.726L45.2 16.508h-.183v2.89h-1.402v-7.195h2.08zm-.68 3.312h.41c.897 0 1.372-.389 1.372-1.112 0-.7-.475-1.067-1.35-1.067h-.431v2.18z",
    fill: "#000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.932 15.828v-.002A3.826 3.826 0 0127.76 12a3.826 3.826 0 013.828 3.826v.002a3.828 3.828 0 01-7.656 0z",
    fill: "#F46F1B"
  })));
}

export default SvgDiscoverPaymentCard;